import argonianMale from '../../img/portraits/argonian-male.jpg';
import argonianFemale from '../../img/portraits/argonian-female.jpg';
import altmerMale from '../../img/portraits/altmer-male.jpg';
import altmerFemale from '../../img/portraits/altmer-female.jpg';
import bosmerMale from '../../img/portraits/bosmer-male.jpg';
import bosmerFemale from '../../img/portraits/bosmer-female.jpg';
import bretonMale from '../../img/portraits/breton-male.jpg';
import bretonFemale from '../../img/portraits/breton-female.jpg';
import dunmerMale from '../../img/portraits/dunmer-male.jpg';
import dunmerFemale from '../../img/portraits/dunmer-female.jpg';
import imperialMale from '../../img/portraits/imperial-male.jpg';
import imperialFemale from '../../img/portraits/imperial-female.jpg';
import khajiitMale from '../../img/portraits/khajiit-male.jpg';
import khajiitFemale from '../../img/portraits/khajiit-female.jpg';
import nordMale from '../../img/portraits/nord-male.jpg';
import nordFemale from '../../img/portraits/nord-female.jpg';
import orcMale from '../../img/portraits/orc-male.jpg';
import orcFemale from '../../img/portraits/orc-female.jpg';
import redguardMale from '../../img/portraits/redguard-male.jpg';
import redguardFemale from '../../img/portraits/redguard-female.jpg';

// raceId is the Skyrim.esm form id (decimal) of the race record, as saved in
// appearanceDump.raceId. These are the stock vanilla race records:
// ArgonianRace=0x13740, BretonRace=0x13741, DarkElfRace=0x13742,
// HighElfRace=0x13743, ImperialRace=0x13744, KhajiitRace=0x13745,
// NordRace=0x13746, OrcRace=0x13747, RedguardRace=0x13748, WoodElfRace=0x13749.
const PORTRAITS = {
  79680: { male: argonianMale, female: argonianFemale }, // Argonian
  79681: { male: bretonMale, female: bretonFemale }, // Breton
  79682: { male: dunmerMale, female: dunmerFemale }, // Dark Elf
  79683: { male: altmerMale, female: altmerFemale }, // High Elf
  79684: { male: imperialMale, female: imperialFemale }, // Imperial
  79685: { male: khajiitMale, female: khajiitFemale }, // Khajiit
  79686: { male: nordMale, female: nordFemale }, // Nord
  79687: { male: orcMale, female: orcFemale }, // Orc
  79688: { male: redguardMale, female: redguardFemale }, // Redguard
  79689: { male: bosmerMale, female: bosmerFemale }, // Wood Elf
};

export function getCharacterPortrait(raceId, isFemale) {
  const byRace = PORTRAITS[raceId];
  if (!byRace) return null;
  return (isFemale ? byRace.female : byRace.male) || null;
}
